import { render, staticRenderFns } from "./therm-list-item.vue?vue&type=template&id=bc2b9564&scoped=true"
import script from "./therm-list-item.vue?vue&type=script&lang=js"
export * from "./therm-list-item.vue?vue&type=script&lang=js"
import style0 from "./therm-list-item.vue?vue&type=style&index=0&id=bc2b9564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2b9564",
  null
  
)

export default component.exports